import { render } from "./RecentFiles.vue?vue&type=template&id=64b62cd2&scoped=true"
import script from "./RecentFiles.vue?vue&type=script&lang=js"
export * from "./RecentFiles.vue?vue&type=script&lang=js"

import "./RecentFiles.vue?vue&type=style&index=0&id=64b62cd2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b62cd2"]])

export default __exports__